import * as React from "react";
const SvgLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.33325 8H12.6666", stroke: "#888EAA", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgLine;
